export default __webpack_public_path__ + "static/media/Amazon.b8f6caf3.svg";